import React from 'react';
import './App.css';
import Space from './spaces/Space'
import Minimodel from "./attachments/Minimodel";
import { useLiveOperation, useSpaceState } from "./userHooks";
import Gui from './gui'
import liveInstance from "./liveController/createLiveInstance";
// import { WebSocketState } from "@realsee/live/lib/typings/WebSocket";
import { setSpaceStateToStore } from "./slices/spaceSlice";
import { useDispatch } from "react-redux";
import { isApp } from './utils/deviceDetect'
import { useBangsHeightState, useJSBridgeAction } from "@realsee/jsbridge-x/lib/react/hooks";
import { Box } from '@mui/material'
import Barrage from "./gui/_ui/Barrage";
import Toast from './gui/_ui/Toast'
import { BuiltinEventType, BuiltinActionType, BuiltinMsg } from "@realsee/live/lib/typings/LiveMsg";
import { work as defaultWork } from '@realsee/open-works/virtual/81gmMq5a7zbF9leWMk/work'

// console.log({defaultWork})

const MinimodelWithSpace = Space.withSpace(Minimodel)

const { useKeyframe, useReadyState, useLiveEventCallback, useWebSocketEventCallback } = liveInstance

function App() {
    const bandHeight = Math.ceil(useBangsHeightState() / window.devicePixelRatio)
    const [defaultFiveState, setDefaultFiveState] = React.useState()
    const [fiveStateKeyframe, setFiveStateKeyframe] = useKeyframe('FiveState')
    // const wsStatus = useReadyState()
    const [spaceState, setSpaceState] = useSpaceState()
    const { closeLoading } = useJSBridgeAction()
    const { liveConnectFromUrl } = useLiveOperation()
    const { liveExit } = useLiveOperation()
    
    const WrapStyle = {
        position: 'absolute',
        left: 0,
        top: `${bandHeight}px`,
        width: '100%',
        height: '100%',
        pointerEvents: 'none'
    }
    
    // 根据url参数进入带看
    React.useEffect(() => {
        if (isApp) {
            Promise.resolve()
                .then(closeLoading)
                .then(() => liveConnectFromUrl(window.location.href))
                .catch(error => {
                    Toast.error(error.message || '哪里出错了，请刷新后重试！')
                })
        }else {
            Promise.resolve()
                .then(() => liveConnectFromUrl(window.location.href))
                .catch(error => {
                    Toast.error(error.message || '哪里出错了，请刷新后重试！')
                })
        }
    }, [])
    
    /** 纯live相关处理start */
    const [spaceStateKeyframe] = useKeyframe('SpaceState')
    const dispatch = useDispatch()

    React.useEffect(() => {
        if (spaceStateKeyframe && spaceState.mode === 'live') {
            dispatch(setSpaceStateToStore(spaceStateKeyframe))
        }
    }, [spaceStateKeyframe, dispatch, spaceState.mode])
    
    // 带看通道建立，首屏数据同步
    useLiveEventCallback('readyKeyframeSync', (lastKeyframe) => {
        // live channel ready
        setSpaceState({ mode: 'live' }, false)
        Toast.success('进入带看')
        
        // sync first screen frame
        if (JSON.stringify(lastKeyframe) !== '{}') {
            for (const key in lastKeyframe) {
                if (lastKeyframe.hasOwnProperty(key)) {
                    switch (key) {
                        case 'FiveState':
                            setDefaultFiveState(lastKeyframe[key])
                            break
                        default:
                            return
                    }
                }
            }
        }
    })
    
    // 被踢出
    useLiveEventCallback("kickOut", () => {
        liveExit().then(() => {
            // setSpaceState({ mode: 'user' }) // TODO 存疑,为什么不是从wsState里得到的close信息
            Barrage.message('你被踢出带看房间')
        })
    })
    
    // 内置事件监听
    useLiveEventCallback("builtinEvent", (builtinMsg) => {
        switch (builtinMsg.action) {
            case BuiltinActionType.RoomClose:
                console.log('__房间关闭__')
                setSpaceState({ mode: 'user' })
                Toast.success('房间关闭')
                break
            case BuiltinActionType.UserStatus:
                console.log(builtinMsg.data)
                console.log('builtinEvent: user state change')
                break
            case BuiltinActionType.UserInfo:
                console.log('builtinEven: user info change')
                break
            case BuiltinActionType.UserMicroStatus:
                console.log('builtinEvent: user micro change')
                break
            case BuiltinActionType.UserPermission:
                console.log('builtinEvent: user permission change')
                break
            default:
                console.log('builtinEvent: 其他不在枚举内的变更！') // debug
                break
        }
    })
    
    // ws异常提示
    useWebSocketEventCallback("ws.error", (wsError) => {
        Toast.error(wsError.error.message || '哪里出错了，请刷新后重试！')
        console.log(wsError.error.message || '哪里出错了，请刷新后重试！')
    })
    
    
    /** 纯live相关处理end */
    
    // live mode下，five state同步
    React.useEffect(() => {
        if (spaceState.mode === 'live' && fiveStateKeyframe) {
            setDefaultFiveState(fiveStateKeyframe)
        }
    }, [fiveStateKeyframe, spaceState.mode])
    
    function handleDefaultState (state) {
        if (spaceState.mode === 'live') {
            setFiveStateKeyframe(state)
        }
    }
    
  return (
      <section id="app-container">
          {/* 此处可放错误bar等额外信息 */}
          <main>
              <div id="canvas-container">
                  <Space
                      spaceRootId="default-canvas"
                      work={defaultWork}
                      isMain={spaceState.type === 'default'}
                      isSplit={spaceState.split}
                      state={defaultFiveState}
                      onStateChange={handleDefaultState}
                  >
                      {/* attachments */}
                      <Box sx={WrapStyle}>
                          <MinimodelWithSpace/>
                      </Box>
                  </Space>
              </div>
              {/* gui不含任何space相关操作能力 */}
              <div id="gui" style={{ paddingTop: `${bandHeight}px`}}>
                  <Gui />
              </div>
          </main>
      </section>
  );
}

export default App;
